import { render, staticRenderFns } from "./CoolantView.vue?vue&type=template&id=a6e29282&scoped=true&"
import script from "./CoolantView.vue?vue&type=script&lang=ts&"
export * from "./CoolantView.vue?vue&type=script&lang=ts&"
import style0 from "./CoolantView.vue?vue&type=style&index=0&id=a6e29282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e29282",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
